package studio.goodegg.capsule

import me.tatarka.inject.annotations.Provides
import studio.goodegg.capsule.common.di.ApplicationScope

actual interface FileStorageLocationComponent {
    @Provides
    @ApplicationScope
    fun providesFileStorage(): FileStorageLocation = FileStorageLocation("data/files")
}